<template>
  <div v-show="visible">
    <a-modal
      v-model:visible="visible"
      @cancel="handleCancel"
      :centered="true"
      :destroyOnClose="false"
      width="80%"
      :bodyStyle="{
        paddingBottom: 0
      }"
      :dialogStyle="{
        filter: `${showMasker ? 'blur(4px)' : ''}`
      }"
      :footer="null"
      class="patient-wrap"
      dialogClass
    >
      <template #title>
        <div class="title_wrap">
          <span
            @click="goDetail(it.value)"
            v-for="(it, index) in titles"
            :key="it.value"
            :class="{ actived: activeKey === it.value }"
          >
            {{ it.label }}
            <span class="split_flag" v-if="index !== titles.length - 1">/</span>
          </span>
        </div>
      </template>
      <div class="doctor_bind_patient" v-show="activeKey === 'doctor'">
        <Patient
          ref="patientRef"
          :isInModal="true"
          :params="recordData.docotorInfo"
          :mode="activeKey"
          @patientBindDoct="patientBindDoct"
          @seeInfo="seeInfo"
          :immediately="true"
        >
          <template #title>
            <div class="title">
              <span class="role">医生</span>
              <span>{{ recordData.docotorInfo.doctorName }}</span>
              <span class="phone">{{ recordData.docotorInfo.doctorPhone }}</span>
              <auth-img :src="see_detail" @click="seeInfo(recordData.docotorInfo.doctorId, 2)" />
            </div>
          </template>
        </Patient>
      </div>
      <div class="doctor_bind_patient" v-show="activeKey === 'bdBindPatient'">
        <Patient
          :isInModal="true"
          :params="recordData.bdInfo"
          :mode="activeKey"
          @patientBindDoct="patientBindDoct"
          @seeInfo="seeInfo"
          :immediately="true"
        >
          <template #title>
            <div class="title bd">
              <span class="role">BD</span>
              <span>{{ recordData.bdInfo.hname }}</span>
              <span class="phone">{{ recordData.bdInfo.phone }}</span>
              <auth-img :src="see_detail" @click="seeInfo(recordData.bdInfo.hid, 3)" />
            </div>
          </template>
        </Patient>
      </div>
      <div v-show="activeKey === 'patient'">
        <PatientBindDoct :params="recordData.patientInfo" @seeInfo="seeInfo" />
      </div>
      <div v-show="activeKey === 'bd'">
        <Doct
          :immediately="true"
          :params="recordData.bdInfo"
          :mode="activeKey"
          @doctBindPatients="doctBindPatients"
        >
          <template #title>
            <div class="title bd">
              <span class="role">BD</span>
              <span>{{ recordData.bdInfo.hname }}</span>
              <span class="phone">{{ recordData.bdInfo.phone }}</span>
              <auth-img :src="see_detail" @click="seeInfo(recordData.bdInfo.hid, 3)" />
            </div>
          </template>
        </Doct>
      </div>
    </a-modal>
    <UserInfo ref="userInfoRef" @close="showMasker = false" />
  </div>
</template>
<script setup>
import Patient from '@/views/UserPool/patient'
import PatientBindDoct from '@/views/UserPool/components/patientBindDoct'
import Doct from '@/views/UserPool/doctor'
import { ref, defineExpose, reactive, onDeactivated, onActivated } from 'vue'
import see_detail from '@/assets/img/see_detail.png'

import UserInfo from '@/views/UserPool/components/UserInfo'

const activeKey = ref('doctor')
const showMasker = ref(false)
const userInfoRef = ref(null)
const patientRef = ref(null)
const titles = ref([{ label: '单个医生绑定患者数', value: 'doctor' }])
const recordData = reactive({
  // 存储当前页面跳转的参数
  docotorInfo: {},
  patientInfo: {},
  bdInfo: {}
})
const visible = ref(false)
// watch(
//   () => activeKey.value,
//   val => {
//     console.log('当前弹窗类型为------', val)
//   },
//   { immediate: true }
// )
const initModal = row => {
  console.log('当前弹窗类型为------', row.mode)
  if (row.mode === 'doctor') {
    activeKey.value = 'doctor'
    titles.value = [{ label: '单个医生绑定患者数', value: 'doctor' }]
    recordData.docotorInfo = row
  } else if (row.mode === 'patient') {
    activeKey.value = 'patient'
    titles.value = [{ label: '单个患者绑定医生数', value: 'patient' }]
    recordData.patientInfo = row
  } else if (row.mode === 'bd') {
    activeKey.value = 'bd'
    titles.value = [{ label: 'BD备案客户数', value: 'bd' }]
    recordData.bdInfo = row
  } else if (row.mode === 'bdBindPatient') {
    activeKey.value = 'bdBindPatient'
    titles.value = [{ label: 'BD绑定患者数', value: 'bdBindPatient' }]
    recordData.bdInfo = row
  }
  visible.value = true
}
const handleCancel = () => {
  visible.value = false
  handleRevisitToggle(false)
}

const wasVisible = ref(false) // 保存失活前弹窗状态，激活时恢复
// keep-alive 缓存导致路由跳转时弹窗不关闭，在组件失活时关闭弹窗
onDeactivated(() => {
  wasVisible.value = visible.value
  visible.value = false
})

onActivated(() => {
  if (wasVisible.value) {
    visible.value = true
    wasVisible.value = false
  }
})

// 单个患者绑定的医生
const patientBindDoct = row => {
  const list = titles.value
  const newTitils = '单个患者绑定医生数'
  activeKey.value = 'patient'
  if (list.find(it => it.label === newTitils)) {
    // 替换参数,重新查询单个患者绑定的医生
  } else {
    list.push({
      label: newTitils,
      value: 'patient'
    })
    titles.value = list
  }
  recordData.patientInfo = row
}
// 单个医生绑定患者
const doctBindPatients = row => {
  const list = titles.value
  const newTitils = '单个医生绑定患者数'
  activeKey.value = 'doctor'
  if (list.find(it => it.label === newTitils)) {
    //
  } else {
    list.push({
      label: newTitils,
      value: 'doctor'
    })
    titles.value = list
  }
  recordData.docotorInfo = row
}
const goDetail = key => {
  activeKey.value = key
}
const seeInfo = (id, type, ucDoctorId) => {
  const params = {
    accountType: type,
    id,
    ucDoctorId
  }
  showMasker.value = true
  userInfoRef?.value.initModal(params)
}

const handleRevisitToggle = isActive => {
  patientRef.value?.handleRevisitToggle(isActive)
}
// 主动回访 end

defineExpose({ initModal })
</script>
<style scoped lang="scss">
.title_wrap {
  span {
    color: #00000066;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    &:hover {
      color: #1890ff;
    }
    .split_flag {
      margin: 0 10px;
      color: #00000066;
    }
  }
  .actived {
    color: #000000d9;
  }
}
.doctor_bind_patient {
  position: relative;
}

.title {
  padding: 5px 7px;
  background: #1890ff1a;
  border-radius: 4px;
  width: fit-content;
  line-height: initial;
  display: flex;
  align-items: center;
  span {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    margin-right: 8px;
  }
  .role {
    border: 1px solid #1890ff;
    border-radius: 4px;
    padding: 1px 4px;
    font-size: 12px;
    color: #1890ff;
  }
  .phone {
    border-left: 2px solid #333333;
    padding-left: 8px;
  }
  img {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  &.bd {
    background: #1fb5ab1a;
    .role {
      border: 1px solid #1fb5ab;
      color: #1fb5ab;
    }
  }
}
</style>
